<template>
  <div>
    <v-row>
      <v-col cols="8"><h2>{{frage.content_title}}</h2>
        {{frage.content_text}}
      </v-col>
  
    </v-row>
  </div>
</template>

<script setup>
  import { getCurrentInstance,ref,onMounted } from "vue";
  import BaseCalls from "@/services/BaseCalls";
  import { useRoute } from "vue-router";
  const frage = ref(false);
  const route = useRoute();
  const { proxy } = getCurrentInstance();


  async function getContentKey() {
    console.log(route.params.key);
    let berSelect = {};
    berSelect.action = "getContentKey";
    berSelect.content_speaking_link = route.params.key;
   
    try {
      const resp = await BaseCalls.postMixedNew(berSelect); // Korrigiert, um .value zu verwenden
      if (resp.data && resp.data.content) {
        console.log(resp.data.content);
        frage.value = resp.data.content;
        setTitle(frage.value);
      }
    } catch (err) {
      console.log("error frage ");
    }
  }
const setTitle = (frage) => {
  proxy.$updateDocumentHead(
    frage.conten_title,
    frage.content_text?.substring(0, 140) || ''  // Truncate to 140 characters
  );
};
onMounted(() => {
  getContentKey();
});
</script>
